<div
  [class.disabled]="readOnly"
  [class.dragging-over]="isDraggingOver"
  [class.fullscreen]="isFullscreen"
  [class.loading]="isLoading"
  [class.uploading]="isUploading"
  class="tiptap-editor-container"
>
  <div *ngIf="!field?.props?.hideToolbar" [class.readonly]="readOnly" class="tiptap-toolbar">
    <div class="toolbar-group">
      <button
        [class.active]="isFormatActive('bold')"
        (click)="applyFormat('bold')"
        class="toolbar-button"
        tabindex="-1"
        title="Bold"
        type="button"
      >
        <fa-icon icon="bold"></fa-icon>
      </button>
      <button
        [class.active]="isFormatActive('italic')"
        (click)="applyFormat('italic')"
        class="toolbar-button"
        tabindex="-1"
        title="Italic"
        type="button"
      >
        <fa-icon icon="italic"></fa-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <div class="toolbar-group">
      <button
        [class.active]="isFormatActive('bulletList')"
        (click)="applyFormat('bulletList')"
        class="toolbar-button"
        tabindex="-1"
        title="Bullet List"
        type="button"
      >
        <fa-icon icon="list-ul"></fa-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <div class="toolbar-group">
      <button
        (click)="toggleEmojiPicker()"
        class="toolbar-button emoji-button"
        tabindex="-1"
        title="Insert emoji"
        type="button"
      >
        <fa-icon icon="smile"></fa-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <div class="toolbar-group">
      <div class="image-button-container">
        <button
          #imageButton
          [disabled]="isUploading"
          (click)="toggleImageSourceTooltip()"
          class="toolbar-button"
          tabindex="-1"
          title="Insert image"
          type="button"
        >
          <fa-icon icon="image"></fa-icon>
        </button>
        <div *ngIf="showImageSourceTooltip" class="image-source-tooltip">
          <button (click)="handleImageSourceSelection(ImageSource.UPLOAD)" class="tooltip-option" type="button">
            <fa-icon class="me-2" icon="upload"></fa-icon>
            {{ "Upload file" | translate }}
          </button>
          <button (click)="handleImageSourceSelection(ImageSource.GALLERY)" class="tooltip-option" type="button">
            <fa-icon class="me-2" icon="images"></fa-icon>
            {{ "From gallery" | translate }}
          </button>
        </div>
      </div>
      <button
        [disabled]="isUploading"
        (click)="uploadFile()"
        class="toolbar-button"
        tabindex="-1"
        title="Attach file"
        type="button"
      >
        <fa-icon icon="paperclip"></fa-icon>
      </button>
    </div>

    <div class="toolbar-divider"></div>

    <div class="toolbar-group">
      <div [class.show]="moreOptionsDropdown" class="font-size-dropdown position-relative">
        <button
          (click)="toggleFontSizeDropdown()"
          class="toolbar-button"
          tabindex="-1"
          title="More options"
          type="button"
        >
          <fa-icon icon="ellipsis-v"></fa-icon>
        </button>
        <div [class.show]="moreOptionsDropdown" class="dropdown-menu">
          <button
            [class.active]="getCurrentFontSize() === 'Small'"
            (click)="applyFontSize('small')"
            class="dropdown-item"
            type="button"
          >
            <fa-icon class="me-2" icon="minus"></fa-icon>
            Small (75%)
          </button>
          <button
            [class.active]="getCurrentFontSize() === 'Medium'"
            (click)="applyFontSize('medium')"
            class="dropdown-item"
            type="button"
          >
            <fa-icon class="me-2" icon="font"></fa-icon>
            Medium (100%)
          </button>
          <button
            [class.active]="getCurrentFontSize() === 'Large'"
            (click)="applyFontSize('large')"
            class="dropdown-item"
            type="button"
          >
            <fa-icon class="me-2" icon="plus"></fa-icon>
            Large (150%)
          </button>
          <div class="dropdown-divider"></div>
          <button
            [class.active]="isFormatActive('strike')"
            (click)="applyFormatFromDropdown('strike')"
            class="dropdown-item"
            type="button"
          >
            <fa-icon class="me-2" icon="strikethrough"></fa-icon>
            {{ "Strikethrough" | translate }}
          </button>
          <button
            [class.active]="isFormatActive('orderedList')"
            (click)="applyFormatFromDropdown('orderedList')"
            class="dropdown-item"
            type="button"
          >
            <fa-icon class="me-2" icon="list-ol"></fa-icon>
            {{ "Numbered list" | translate }}
          </button>
          <button (click)="toggleLinkFromDropdown()" class="dropdown-item" type="button">
            <fa-icon class="me-2" icon="link"></fa-icon>
            {{ "Insert link" | translate }}
          </button>
          <button (click)="toggleSymbolFromDropdown()" class="dropdown-item" type="button">
            <fa-icon class="me-2" icon="hashtag"></fa-icon>
            {{ "Insert symbol" | translate }}
          </button>
          <button (click)="insertMath()" class="dropdown-item" type="button">
            <fa-icon class="me-2" icon="square-root-alt"></fa-icon>
            {{ "Insert math" | translate }}
          </button>
          <div class="dropdown-divider"></div>
          <button (click)="toggleFullscreen()" class="dropdown-item" type="button">
            <fa-icon [icon]="isFullscreen ? 'compress' : 'expand'" class="me-2"></fa-icon>
            {{ (isFullscreen ? "Exit fullscreen" : "Fullscreen") | translate }}
          </button>
          <button (click)="clearFormatting()" class="dropdown-item" type="button">
            <fa-icon class="me-2" icon="eraser"></fa-icon>
            {{ "Clear formatting" | translate }}
          </button>
        </div>

        <div *ngIf="showLinkTooltip" class="link-tooltip link-tooltip-dropdown">
          <div class="link-tooltip-content">
            <input
              #linkUrlInput
              [ngModelOptions]="{ standalone: true }"
              (keydown.enter)="insertLink()"
              (keydown.escape)="closeLinkTooltip($event)"
              class="form-control form-control-sm mb-2"
              [(ngModel)]="linkUrl"
              placeholder="{{ 'URL' | translate }}"
              required
              type="url"
            />
            <input
              [ngModelOptions]="{ standalone: true }"
              (keydown.enter)="insertLink()"
              (keydown.escape)="closeLinkTooltip($event)"
              class="form-control form-control-sm mb-2"
              [(ngModel)]="linkText"
              placeholder="{{ 'Link text (optional)' | translate }}"
              type="text"
            />
            <div class="d-flex justify-content-end gap-2">
              <button (click)="closeLinkTooltip($event)" class="btn btn-sm btn-outline-secondary" type="button">
                {{ "Cancel" | translate }}
              </button>
              <button
                *ngIf="isEditingLink()"
                (click)="removeLink()"
                class="btn btn-sm btn-outline-danger"
                type="button"
              >
                {{ "Remove link" | translate }}
              </button>
              <button [disabled]="!linkUrl" (click)="insertLink()" class="btn btn-sm btn-primary" type="button">
                {{ isEditingLink() ? ("Update" | translate) : ("Insert" | translate) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div #editorElement [attr.data-placeholder]="placeholder" [id]="field?.id" class="tiptap-content"></div>

  <div *ngIf="field?.props?.maxLength && editor && !field?.props?.hideCharacterCount" class="character-count">
    <span
      >{{ currentCharacterCount }} {{ "characters" | translate
      }}<span *ngIf="shouldShowByteCount" [ngClass]="byteCountClass" class="ms-1">({{ byteCountText }})</span></span
    >
    <button
      *ngIf="currentCharacterCount > 0"
      [title]="'Clear' | translate"
      (click)="clearContent()"
      class="btn btn-link btn-sm btn-no-block text-muted p-0 ms-3 clear-button"
      type="button"
    >
      <span class="text-decoration-underline">
        {{ "Clear" | translate }}
      </span>
    </button>
  </div>

  <div [style.display]="showEmojiPicker ? 'block' : 'none'" class="emoji-picker-container">
    <div #emojiPicker class="emoji-picker-wrapper"></div>
  </div>

  <div *ngIf="showSymbolPicker" (click)="toggleSymbolPicker()" class="symbol-picker-container">
    <div (click)="$event.stopPropagation()" class="symbol-picker-modal">
      <div class="symbol-picker-header">
        <h5>{{ "Insert Symbol" | translate }}</h5>
        <button (click)="toggleSymbolPicker()" class="btn-close" aria-label="Close" type="button"></button>
      </div>
      <div class="symbol-picker-content">
        <div *ngFor="let category of symbolCategories" class="symbol-category">
          <h6 class="symbol-category-title">{{ category.name | translate }}</h6>
          <div class="symbol-grid">
            <button
              *ngFor="let symbol of category.symbols"
              [title]="symbol"
              (click)="insertSymbol(symbol)"
              class="symbol-button-item"
              type="button"
            >
              {{ symbol }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div *ngIf="isUploading" class="upload-indicator">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
      <span class="visually-hidden">Uploading...</span>
    </div>
    <span class="ms-2">{{ "Uploading..." | translate }}</span>
  </div>
</div>
